
import { Options, mixins } from "vue-class-component";
import { ActionTypes } from "../../store";
import Toaster from "../../helpers/Toaster";
import router from "../../router";
import UtilityOptions from "../../mixins/UtilityOptions";

@Options({
  components: {},
  title: "Forbidden Access",
})
export default class ForbiddenAccess extends  mixins(UtilityOptions) {

  goHome() {
    router.push({ path: "/home/dashboard" });
  }
 
}
